import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _styled from '@emotion/styled-base';
import 'core-js/modules/es6.string.small.js';
import { Classes } from '@blueprintjs/core';
import { Root, Content } from '@radix-ui/react-dropdown-menu';
import cx from 'classnames';
import React__default from 'react';
import { isIE11 } from '../../utils/isIE11.js';
import { usePopperJsPositioning } from '../popover/utils.js';
import { Heading } from './dropdown-menu-heading.js';
import { DropdownMenuSubTrigger } from './dropdown-menu-item.js';
import { menuHeights, menuWidths } from './utils/dropdown-menu-constants.js';

var _excluded = ["children", "placement"];

var StyledListComponent = /*#__PURE__*/_styled("ul", {
  target: "e17i2sys0"
})({
  name: "1rye7jo",
  styles: "overflow:hidden auto;"
});

var SubMenu = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      placement = _ref.placement,
      props = _objectWithoutProperties(_ref, _excluded);

  var popperContentStyle = {
    maxHeight: menuHeights.large,
    maxWidth: menuWidths.small
  };
  var popperContent = /*#__PURE__*/React__default.createElement(StyledListComponent, {
    className: cx(Classes.MENU),
    style: popperContentStyle
  }, children);

  var _usePopperJsPositioni = usePopperJsPositioning({
    className: cx("vds-dropdown-menu", "vds-popover"),
    arrowType: "none",
    content: popperContent,
    triggerRef: ref,
    portaled: false,
    placement: placement
  }),
      rootProps = _usePopperJsPositioni.rootProps,
      triggerProps = _usePopperJsPositioni.triggerProps,
      contentProps = _usePopperJsPositioni.contentProps;

  if (isIE11()) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Heading, {
      ref: ref
    }, props.text), children);
  }

  return /*#__PURE__*/React__default.createElement(Root, rootProps, /*#__PURE__*/React__default.createElement(DropdownMenuSubTrigger, _extends({}, props, {
    ref: triggerProps.ref
  })), /*#__PURE__*/React__default.createElement(Content, contentProps));
});

export { SubMenu };
//# sourceMappingURL=dropdown-sub-menu.js.map
